<template>
  <section v-if="!loading && items">
    <div class="text-center my-6">
      <p class="text-h4 font-weight-bold header-page">
        {{ $t("Adsconditions") }}
      </p>
    </div>
    <div v-html="items" class="text-content text-center"></div>
  </section>
  <v-row v-else>
    <template v-if="loading">
      <v-col cols="12" v-for="text in texts" :key="text">
        <v-skeleton-loader
          class="mx-auto border-0"
          type="paragraph"
        ></v-skeleton-loader>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12" class="d-flex justify-center align-center">
        <div class="no-services-card">
          <p class="no-services-text">{{ $t('There_is_no_data') }}</p>
        </div>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import crudDataService from "@/Services/crudDataService";
export default {
  data() {
    return {
      items: "",
      texts: [1, 2, 3, 4,5],
      loading: true,
    };
  },

  methods: {
    async adsconditions() {
      this.loading = true;
      try {
        let response = await crudDataService.getAll("application-data");
        this.items = response.data.data.ad_conditions;
      } catch (e) {
        this.items = "";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.adsconditions();
  },
  };
</script>
<style scoped>
.header-page {
  color: rgba(17, 24, 39, 1);
}
.text-content {
  font-size: 28px;
  line-height: 1.9;
  font-weight: 500;
}
.no-services-card {
  background: #0074c7;
  border-radius: 16px;
  padding: 40px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}
.no-services-text {
  color: #fff;
  font-size: 2.2rem;
  font-weight: bold;
  margin: 0;
  text-shadow: 1px 1px 4px #00000055;
}
</style>

